export const getContentWrapperClass = (props) => {
  return props?.accountReducer?.kybStatus?.kyb_status !== 2
    ? "contentWrapper mt-112"
    : "contentWrapper";
};

export const getContentWrapperHeight = (props) => {
  return props?.accountReducer?.kybStatus?.kyb_status !== 2 ? "112px" : "72px";
};
